import TutorialEndScreen from "./TutorialEndScreen";

export default TutorialEndScreen;


// WEBPACK FOOTER //
// /src/components/tutorialEndScreen/index.js